import React, { useState } from 'react';
import { CaseEntry } from './CaseChatEntry';
import { useAppContext } from '../../Services/AppContext';
import MediaViewerModal from '../MediaViewer/MediaViewerModal';
import AttachmentButton from '../Button/AttachmentButton';
import { useEffectAsync } from '../../helpers';
import apiClient from '../../Services/ApiClient';

interface Props {
	entry: CaseEntry;
}

const imageExtensions = ['jpg', 'jpeg', 'png', 'gif'];

const CaseChatEntryDocumentation: React.FC<Props> = ({ entry }) => {
	const { socketUrl } = useAppContext();
	const [mediaViewerOpened, setMediaViewerOpened] = useState(false);
	const [fileToViewer, setFileToViewer] = useState<any>();

	useEffectAsync(async () => {
		const fileData = await apiClient.get(
			'/patients/' +
				entry.extra.userId +
				'/documentation/' +
				entry.extra.fileId +
				'/raw',
		);

		const fileType =
			imageExtensions.indexOf(fileData?.data?.ext) !== -1
				? 'image'
				: fileData?.data?.ext === 'pdf'
				? 'pdf'
				: 'none';

		const file = {
			id: fileData?.data?.id,
			name: '',
			displayName: fileData?.data?.name,
			type: fileType,
			preview:
				socketUrl +
				'/patients/' +
				entry.extra.userId +
				'/documentation/' +
				fileData?.data?.folderId +
				'/' +
				fileData?.data?.id +
				'/preview',
			download:
				socketUrl +
				'/patients/' +
				entry.extra.userId +
				'/documentation/' +
				fileData?.data?.folderId +
				'/' +
				fileData?.data?.id +
				'?download=1',
		};

		setFileToViewer(file);
	}, []);

	return (
		<>
			<div className='mb-2'>{entry.message}</div>
			{fileToViewer && (
				<>
					<AttachmentButton
						onClick={() => setMediaViewerOpened(true)}
						title={'base.shared.show'}
					/>
					<MediaViewerModal
						opened={mediaViewerOpened}
						onClose={() => setMediaViewerOpened(false)}
						file={fileToViewer}
					/>
				</>
			)}
		</>
	);
};

export default CaseChatEntryDocumentation;
